import React from "react";

const TRIANGLE_RED = '#F84F31';
const TRIANGLE_GREEN = '#23c552';

const Rows = ({ rowData, index,onOpen,dataIndex,sheetType,soSelected,RevCmptCheckList}) => {

        const sheetReview = RevCmptCheckList !== undefined ? RevCmptCheckList.filter(sheet => sheet.uniqueCode === rowData.uniqueCode) : undefined;
        const sheetData2 = sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === 'desc') : undefined;
        let desc ;
        let descType ;
        let cmptCheck = false;

        if(sheetData2 !== undefined && sheetReview[sheetData2] !== undefined && sheetData2 > -1){
                desc = true;
                descType = sheetReview[sheetData2].cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN;
                cmptCheck = true;
        }else{
                desc = false;
        }

        return <tr>
            <td style={{textAlign: "center"}}>{index+1}</td>
{/*            <td title={rowData.seqCode}>
                {rowData.seqCode}
            </td>*/}
            <td onClick={() => {
                //     onOpen({name:"label"},rowData.uniqueCode);
                //     handleClickSQTable("label",index);
            }}
            style={{cursor:"pointer",overflow:"hidden",position: "relative",background: soSelected.name === "label" && soSelected.index === index ? "#eee" : "transparent"}}>
                    <span>{rowData.label}</span>
            </td>
            <td onClick={() =>{
                    onOpen({name:"desc"},rowData.uniqueCode,cmptCheck)
            }}
                style={{cursor:"pointer",overflow:"hidden",position: "relative",background: soSelected.name === "desc" && soSelected.index === index ? "#eee" : "transparent"}}>
                    {desc? <div style={{position: "absolute", backgroundColor: descType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                    <span>{rowData.desc}</span>
            </td>
            <td style={{textAlign: "center"}}>
                {rowData.repeat}
            </td>
            <td className="cancle"></td>
        </tr>
    
}

export default Rows;
